import React from 'react'
import styles from '../styles'
import { discount, robot } from '../assets'
import GetStarted from './GetStarted'

export default function Hero() {
  return (
    <>
      <section id='home' className={`flex md:flex-row flex-col ${styles.paddingY}`}>
        <div className={`flex-1 ${styles.flexStart} flex-col xl:px-0 sm:px-16 px-6`}>
          <div className={`flex flex-row items-center py-[6px] px-4 bg-discount-gradient rounded-[10px] mb-2`}>
            <img src={discount} alt='discount' className='h-[24px] w-[24px]'/>
            <p className={`${styles.paragraph} ml-2`}>
              <span className='text-white'>20% </span>
               Discount For {" "}
              <span className='text-white'> 1 Month </span>
               Account
            </p>
          </div>

          <div className='flex flex-row justify-between items-center w-full'>
            <h1 className='flex-1 text-white font-poppins font-semibold ss:text-[72px] text-[52px] ss:leading-[100px] leading-[75px]'>
              The Next <br className='sm:block hidden' /> {" "} 
              <span className='text-gradient'>Generation</span> {" "}
            </h1>
            <div className='ss:flex hidden md:mr-4 mr-0'>
              <GetStarted />
            </div>
          </div>

          <h1 className='text-white font-poppins font-semibold ss:text-[68px] text-[52px] ss:leading-[100px] leading-[75px] w-full'>
              Payment Method.
          </h1>

          <p className={`${styles.paragraph} max-w-[470px] mt-5`}>Our team of experts uses a methodology to identify the credit cards most likely to fit your needs. 
            We examine annual percentage rates, annual fees.
          </p>
        </div>

        <div className={`${styles.flexCenter} flex-1 md:my-0 my-10 relative`}>
          <img src={robot} alt='billing' className='w-[100%] h-[100%] z-[5]' />
          <div className='absolute z-[0] top-0 w-[40%] h-[35%] pink__gradient'></div>
          <div className='absolute z-[1] bottom-40 w-[80%] h-[80%] white__gradient'></div>
          <div className='absolute z-[0] right-20 bottom-20 w-[50%] h-[50%] blue__gradient'></div>
        </div>

        <div className={`ss:hidden ${styles.flexCenter}`}>
          <GetStarted />
        </div>
      </section>
    </>
  )
}
